import { request } from './client';

export type GoogleStatus = {
	connected: boolean;
	configured: boolean;
	email: string | null;
	redirect_uri: string;
};

export const googleApi = {
	getStatus: () => request<GoogleStatus>('/google/status'),
	getAuthUrl: () => request<{ url: string }>('/google/auth-url'),
	disconnect: () =>
		request<{ connected: boolean }>('/google/disconnect', { method: 'DELETE' }),
	uploadCredentials: (data: FormData) =>
		request('/google/credentials', { method: 'POST', body: data }),
	deleteCredentials: () =>
		request<{ configured: false }>('/google/credentials', { method: 'DELETE' }),
	getCredentials: () =>
		request<
			| {
					configured: false;
					project_id: never;
					client_id: never;
			  }
			| {
					configured: true;
					project_id: string;
					client_id: string;
			  }
		>('/google/credentials'),
};
